import { type ComponentType, type FC, type PropsWithChildren, createContext, useContext } from "react";
import { type AccessScope, ACCESS_SCOPE_MAIN_APP } from "../http/types/accessControl";

export type AppContextType = {
  // true for single-module apps (e.g. deck designer), which have no concept of projects
  isSingleModuleApp: boolean;
  // which of the 4 deployed apps this is - sent on every API call as the X-App-Scope header, so
  // the backend can apply that scope's own lock switch / allow-block list (see AccessService on
  // the backend, and useApi() below).
  scope: AccessScope;
  // the app's brand mark, drawn white for the dark header bar - used by the nav bar and by the
  // access-denied page, which has to render without the rest of the app
  Logo: ComponentType;
};

const AppContext = createContext<AppContextType>({
  isSingleModuleApp: false,
  scope: ACCESS_SCOPE_MAIN_APP,
  Logo: () => null,
});

export const AppProvider: FC<PropsWithChildren<AppContextType>> = ({ isSingleModuleApp, scope, Logo, children }) => (
  <AppContext.Provider value={{ isSingleModuleApp, scope, Logo }}>{children}</AppContext.Provider>
);

export const useAppContext = (): AppContextType => useContext(AppContext);

export default AppContext;
